import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs/internal/Observable';

import { TemplateForBox } from '@df/interfaces';
import { MAIN_DOMAIN } from '@app/app.constants';

@Injectable({
    providedIn: 'root'
})
export class TemplateService {
    public templatesForBoxes: Array<TemplateForBox> = [];

    constructor(private http: HttpClient) {}

    sendTemplateRequestByFilesID(number_of_exercises: number, box_files_IDs: Array<number>): Observable<any> {
        const data = { files: box_files_IDs, number_of_exercises: number_of_exercises };
        return this.http.post<any>(`${MAIN_DOMAIN}/api/tasks/card/template/`, data);
    }
}
